import { useDisputeType } from 'hooks';
import { 
    useRefreshAllDisputeSummaries, 
    useRefreshDeductionDetails, 
    useRefreshInvoiceDetails, 
    useRefreshPaymentDetails 
} from 'state';
import { AdjustmentDetail } from 'types';

export default function useRefreshOnDisputeCreated(disputeRows: AdjustmentDetail[]) {
    const firstRow = disputeRows[0];
    const { adjustmentTypeId, invoiceId, paymentIdRef, vendorId, accountId } = firstRow;
    const refreshInvoice = useRefreshInvoiceDetails(accountId ?? '', vendorId ?? '', invoiceId ?? '');
    const refreshPayment = useRefreshPaymentDetails(accountId ?? '', vendorId ?? '', paymentIdRef ?? '');
    const refreshDisputes = useRefreshAllDisputeSummaries();
    const refreshDeduction = useRefreshDeductionDetails(accountId ?? '', vendorId ?? '', invoiceId ?? '');
    const { isPayment, isInvoice } = useDisputeType(adjustmentTypeId);
    
    return () => {
        if (isInvoice) {
            refreshInvoice();
        }
        if (isPayment) {
            refreshDeduction();
            refreshPayment();
        }
        refreshDisputes();
    };
};